"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.getContainerType = exports.containerTags = exports.sentencesContainerTags = exports.articlesContainerTags = exports.toplevelContainerTags = exports.rootContainerTags = exports.ContainerType = void 0;
const std = __importStar(require("../../law/std"));
var ContainerType;
(function (ContainerType) {
    ContainerType["ROOT"] = "ROOT";
    ContainerType["TOPLEVEL"] = "TOPLEVEL";
    ContainerType["ARTICLES"] = "ARTICLES";
    ContainerType["SENTENCES"] = "SENTENCES";
})(ContainerType || (exports.ContainerType = ContainerType = {}));
exports.rootContainerTags = ["Law"];
exports.toplevelContainerTags = ["EnactStatement", "Preamble", "MainProvision", "SupplProvision", ...std.appdxItemTags];
exports.articlesContainerTags = [...std.articleGroupTags, ...std.supplProvisionAppdxItemTags];
exports.sentencesContainerTags = [
    "Article",
    ...std.paragraphItemTags,
    "Table",
    "TableRow",
    "TableColumn",
];
exports.containerTags = [
    ...exports.rootContainerTags,
    ...exports.toplevelContainerTags,
    ...exports.articlesContainerTags,
    ...exports.sentencesContainerTags,
];
const getContainerType = (tag) => {
    if (exports.rootContainerTags.indexOf(tag) >= 0)
        return ContainerType.ROOT;
    else if (exports.toplevelContainerTags.indexOf(tag) >= 0)
        return ContainerType.TOPLEVEL;
    else if (exports.articlesContainerTags.indexOf(tag) >= 0)
        return ContainerType.ARTICLES;
    else if (exports.sentencesContainerTags.indexOf(tag) >= 0)
        return ContainerType.SENTENCES;
    else
        return ContainerType.SENTENCES;
};
exports.getContainerType = getContainerType;
let currentID = 0;
class Container {
    el;
    containerID;
    type;
    name;
    num;
    sentenceRange; // half open
    parent = null;
    children = [];
    subParent = null; // skips ARTICLES
    subChildren = []; // skips ARTICLES
    allSentenceEnvs;
    constructor(options) {
        const { el, type = (0, exports.getContainerType)(el.tag), name, num, containerID = `container-${currentID}-tag_${el.tag}-type_${type}`, sentenceRange = [NaN, NaN], allSentenceEnvs,
        // parent = null,
        // children = [],
        // subParent = null,
        // subChildren = [],
         } = options;
        currentID++;
        this.containerID = containerID;
        this.el = el;
        this.type = type;
        this.name = name;
        this.num = num;
        this.sentenceRange = sentenceRange;
        this.allSentenceEnvs = allSentenceEnvs;
        // this.parent = parent;
        // this.children = children;
        // this.subParent = subParent;
        // this.subChildren = subChildren;
    }
    addChild(child) {
        this.children.push(child);
        child.parent = this;
        if (child.type !== ContainerType.ARTICLES) {
            const subParent = this.type !== ContainerType.ARTICLES
                ? this
                : this.closest(container => container.type !== ContainerType.ARTICLES);
            if (!subParent)
                throw new Error();
            subParent.subChildren.push(child);
            child.subParent = subParent;
        }
        return this;
    }
    thisOrClosest(func) {
        if (func(this))
            return this;
        return this.parents(func).next().value || null;
    }
    closest(func) {
        return this.parents(func).next().value || null;
    }
    *parents(func) {
        if (!this.parent)
            return;
        if (!func || func(this.parent))
            yield this.parent;
        yield* this.parent.parents(func);
    }
    linealAscendant(func) {
        const ret = [...this.parents(func)].reverse();
        if (!func || func(this))
            ret.push(this);
        return ret;
    }
    findAncestorChildren(func) {
        return this.ancestorChildren(func).next().value || null;
    }
    *ancestorChildren(func) {
        if (!this.parent)
            return;
        yield* this.parent.children.filter(func);
        yield* this.parent.ancestorChildren(func);
    }
    next(func) {
        return this.nextAll(func).next().value || null;
    }
    *nextAll(func) {
        if (!this.parent)
            return;
        for (let i = this.parent.children.indexOf(this) + 1; i < this.parent.children.length; i++) {
            const sibling = this.parent.children[i];
            if (func(sibling))
                yield sibling;
        }
    }
    prev(func) {
        return this.prevAll(func).next().value || null;
    }
    *prevAll(func) {
        if (!this.parent)
            return;
        for (let i = this.parent.children.indexOf(this) - 1; 0 <= i; i--) {
            const sibling = this.parent.children[i];
            if (func(sibling))
                yield sibling;
        }
    }
    thisOrClosestSub(func) {
        if (func(this))
            return this;
        return this.parentsSub(func).next().value || null;
    }
    closestSub(func) {
        return this.parentsSub(func).next().value || null;
    }
    *parentsSub(func) {
        if (!this.subParent)
            return;
        if (func(this.subParent))
            yield this.subParent;
        yield* this.subParent.parentsSub(func);
    }
    findAncestorChildrenSub(func) {
        return this.ancestorChildrenSub(func).next().value || null;
    }
    *ancestorChildrenSub(func) {
        if (!this.subParent)
            return;
        yield* this.subParent.subChildren.filter(func);
        yield* this.subParent.ancestorChildrenSub(func);
    }
    nextSub(func) {
        return this.nextAllSub(func).next().value || null;
    }
    *nextAllSub(func) {
        if (!this.subParent)
            return;
        for (let i = this.subParent.subChildren.indexOf(this) + 1; i < this.subParent.subChildren.length; i++) {
            const sibling = this.subParent.subChildren[i];
            if (func(sibling))
                yield sibling;
        }
    }
    prevSub(func) {
        return this.prevAllSub(func).next().value || null;
    }
    *prevAllSub(func) {
        if (!this.subParent)
            return;
        for (let i = this.subParent.subChildren.indexOf(this) - 1; 0 <= i; i--) {
            const sibling = this.subParent.subChildren[i];
            if (func(sibling))
                yield sibling;
        }
    }
    find(func, cut) {
        return this.findAll(func, cut).next().value || null;
    }
    *findAll(func, cut) {
        for (const child of this.children) {
            if (cut && cut(child))
                return;
            if (!func || func(child))
                yield child;
            yield* child.findAll(func, cut);
        }
    }
    *iterate(func, cut) {
        if (cut && cut(this))
            return;
        if (!func || func(this))
            yield this;
        for (const child of this.children)
            yield* child.iterate(func, cut);
    }
    *iterateReverse(func, cut) {
        if (cut && cut(this))
            return;
        for (let i = this.children.length - 1; 0 <= i; i--) {
            const child = this.children[i];
            yield* child.iterateReverse(func, cut);
        }
        if (!func || func(this))
            yield this;
    }
}
exports.Container = Container;
//# sourceMappingURL=index.js.map